export default __webpack_public_path__ + "static/media/eyeo.2a09dd2c.svg";